import axiosInstance from "../../assets/utils/api";


const getBanner = async (pagename) => {
    try {
        const response = await axiosInstance.get(`/api/banners`, {
            headers: {
                "pagename": pagename,
                "Access-Token": "thof&$EYuYeCr3*ROz_9roKbh",
            }
        })
        return response.data;
    } catch (error) {
        throw error;
    }
};
export default getBanner;